import { resolveEthnicityCode } from "features/patients/utils";

// HSE ethnic-group description → QRISK3 ethrisk category (1–9).
//
// QRISK3 categories: 1 White/not stated, 2 Indian, 3 Pakistani, 4 Bangladeshi,
// 5 Other Asian, 6 Black Caribbean, 7 Black African, 8 Chinese, 9 Other.
//
// Keyed on the resolved DESCRIPTION (normalised: trimmed + lowercased) rather
// than the code, because the backend ethnic-groups `code` may be a SNOMED code
// or a 2-digit HSE code depending on tenant — the description is stable.
//
// Indian / Pakistani / Bangladeshi / Black Caribbean (QRISK 2/3/4/6) have no
// HSE equivalent, so they remain only manually selectable in the calculator.
//
// QRISK3 has no generic "Black" / "Other Black" category — only Black Caribbean
// and Black African. The Irish Black population is predominantly of African
// origin (CSO Census 2022), so Black Irish / Other Black map to Black African (7)
// rather than "Other" (9), which would discard the ethnicity QRISK3 models.
const DESCRIPTION_TO_ETHRISK = {
  "white irish": 1,
  "irish traveller": 1,
  "other white": 1,
  roma: 1,
  ukrainian: 1,
  "black african": 7,
  "black irish": 7,
  "other black": 7,
  chinese: 8,
  "other asian": 5,
  arabs: 9,
  other: 9,
};

// Map a patient's HSE ethnicity to the QRISK3 ethrisk category. Falls back to 1
// ("White or not stated") when the ethnicity is missing or unmapped — matching
// the QRisk3 calculator's previous default.
export const mapEthnicityToQRisk = (ethnicityCode, ethnicGroups) => {
  const code = resolveEthnicityCode(ethnicityCode, ethnicGroups);
  const description = ethnicGroups?.find(
    (group) => group.code === code
  )?.description;

  if (!description) return 1;

  return DESCRIPTION_TO_ETHRISK[description.trim().toLowerCase()] ?? 1;
};
